import StoryblokClient from "storyblok-js-client";
const token = "SZCXr31YuhpadCIyWuI90Qtt"
const storyapi = new StoryblokClient({
    accessToken: token,
  });
export {token, storyapi}